import axios from "../axios";
import { Cookies } from "react-cookie";
const endPoint = `/crm/channels/`;

const cookie = new Cookies();

export const addChannel = async ({ name }) => {
  const token = cookie.get("crm");

  const res = await axios.post(
    `${endPoint}create`,
    { name },
    { headers: { Authorization: token } },
  );
  return res;
};

export const getChannels = async (page) => {
  const token = cookie.get("crm");
  const res = await axios.get(`${endPoint}all?page=${page}`, {
    headers: { Authorization: token },
  });
  return res;
};

export const deleteChannels = async ({ channels }) => {
  const token = cookie.get("crm");
  const res = await axios.put(
    `${endPoint}delete`,
    { channels },
    {
      headers: { Authorization: token },
    },
  );
  return res;
};
